"use strict";

require("core-js/modules/es.symbol.description.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toCompensateForStartOfDay = exports.throwErrorIfIsNotCondition = exports.isLastDate = exports.getGroupName = exports.getChartData = exports.calculateDevicesForChartRequest = void 0;
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.number.to-fixed.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
var _moment = _interopRequireDefault(require("moment/moment"));
var _constants = require("./constants");
var _paulCorePackage = require("paul-core-package");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  ComponentTypes,
  LinkTo
} = _paulCorePackage.constants;
const getGroupName = _ref => {
  let {
    tGroup,
    name,
    index
  } = _ref;
  return "".concat(tGroup, " ").concat(index + 1).concat(name ? ': ' : '').concat(name || '');
};
exports.getGroupName = getGroupName;
const isLastDate = (d, item, i) => i === item.length - 1 && (0, _moment.default)(d.date).minutes();
exports.isLastDate = isLastDate;
const getChartData = _ref2 => {
  let {
    data,
    rangeType
  } = _ref2;
  const iFirstData = Object.values(data).findIndex(v => v.value);
  return Object.values(data).reduce((acc, point, index) => {
    return iFirstData && index < iFirstData ? acc : [...acc, {
      x: (isLastDate(point, data, index) ? (0, _moment.default)(point.date).add(1, _constants.rangeTypesByKey[rangeType]) : (0, _moment.default)(point.date)).format('YYYY-MM-DD HH:mm').toString(),
      y: !isNaN(point.value) ? +point.value.toFixed(2) : null
    }];
  }, []);
};
exports.getChartData = getChartData;
const calcList = _ref3 => {
  let {
    equipmentList,
    acc,
    equipmentType,
    devicesById
  } = _ref3;
  return _objectSpread(_objectSpread({}, acc), {}, {
    [equipmentType]: Object.values(equipmentList).reduce((accEq, eq) => {
      if (!eq || !eq.devicesId) {
        return accEq; // Skip if eq or eq.devicesId is undefined
      }

      return _objectSpread(_objectSpread({}, accEq), {}, {
        [eq.id]: eq.devicesId.reduce((accDev, thingPDIDDevice) => {
          var _devicesById$thingPDI;
          const displayNameId = ((_devicesById$thingPDI = devicesById[thingPDIDDevice]) === null || _devicesById$thingPDI === void 0 || (_devicesById$thingPDI = _devicesById$thingPDI.displayNameId) === null || _devicesById$thingPDI === void 0 ? void 0 : _devicesById$thingPDI.filter(id => _paulCorePackage.constants.regularsByDisplayNameId.temperatureRegex.test(id))) || [];
          return displayNameId.length ? _objectSpread(_objectSpread({}, accDev), {}, {
            [thingPDIDDevice]: displayNameId
          }) : accDev;
        }, {})
      });
    }, {})
  });
};
const calculateDevicesForChartRequest = _ref4 => {
  let {
    activeStructure,
    key = '',
    devicesById
  } = _ref4;
  return Object.keys(activeStructure).reduce((acc, equipmentType) => {
    if (_constants.regKeysForGroupCharts[key].test(equipmentType) && _constants.keysWhatToShowByGroupKey[key][equipmentType]) {
      const equipmentList = activeStructure[equipmentType];
      return calcList({
        equipmentList,
        acc,
        equipmentType,
        devicesById
      });
    } else return acc;
  }, {});
};
exports.calculateDevicesForChartRequest = calculateDevicesForChartRequest;
const throwErrorIfIsNotCondition = (condition, message) => {
  if (!condition) {
    throw new Error(message);
  }
};

/** for compensate for the start of day on the mdm side
 * (if we send from 00:00 with range "hour" - the result is 01:00) */
exports.throwErrorIfIsNotCondition = throwErrorIfIsNotCondition;
const toCompensateForStartOfDay = _ref5 => {
  let {
    rangeType,
    date
  } = _ref5;
  switch (rangeType) {
    case _constants.rangeTypeKey.hour:
      return (0, _moment.default)(date).subtract(1, 'hour');
    case _constants.rangeTypeKey.day:
      return (0, _moment.default)(date).subtract(1, 'day');
    case _constants.rangeTypeKey.minute_1:
      return (0, _moment.default)(date).subtract(1, 'minute');
    case _constants.rangeTypeKey.minute_15:
      return (0, _moment.default)(date).subtract(15, 'minute');
    default:
      return date;
  }
};
exports.toCompensateForStartOfDay = toCompensateForStartOfDay;